import type { Dispatch, FC, ReactNode } from 'react';
import { useState } from 'react';

type UseStateProps = {
  init?: any;
  render: (state: any, setState: Dispatch<any>, init: any) => ReactNode;
};

const UseState: FC<UseStateProps> = (props) => {
  const [init] = useState(props.init);
  const [state, setState] = useState(init);
  return <>{props.render(state, setState, init)}</>;
};

export default UseState;
